module.exports = __webpack_public_path__ + "media/images/willcoates-logo-90c32748899965d35665a64117048164.svg";